export default __webpack_public_path__ + "static/media/YAS0910.34I-41428_-24749_0.970a57a4.jpg";